import deletableMerge from '../../utils/deletableMerge';
import color from '../../components/chemical-highlight/utils/color-config';
// FIXME
import { mark } from '../../lib/api'; // eslint-disable-line
import { get, isObject, findIndex } from 'lodash';

const state = {
    patentId: '',
    isShowPatentList: true,
    permissions: {},
    isEnableKeywordHighlight: false,
    highlightConfig: {
        '@by-preset-source:bio': '#51f584',
        '@by-preset-source:chem': color.common
    },
    isUkLoading: true, // uk 是 chemical 和 bio 跳转过来的时候带的参数，解析这个参数时 isUkLoading 为 true
    listIds: [],
    isOverFreeView: false, // 免费权限一周20篇专利
    overFreeViewMessage: '',
    isShowingCommentBox: false,
    isShowingAddCommentBox: false,
    addCommentBoxPosition: {},
    isShowingEditQuickComment: false,
    quickComment: {
        comment_texts: [],
        predefined_comment_id: ''
    },
    selectedPatentList: [],
};

const mutations = {
    setUkLoading(state, isLoading) {
        state.isUkLoading = isLoading;
    },
    setPatentId(state, patentId) {
        if (state.patentId !== patentId) {
            if (!get(window, 'zPREFACE.globalConfig.userInfo.isSpecialIp')) {
                mark(patentId);
            }
        }
        state.patentId = patentId;
    },
    setPermissions(state, permissions) {
        state.permissions = permissions;
    },
    setIsShowPatentList(state, isShow) {
        state.isShowPatentList = isShow;
    },
    setEnableKeywordHighlight(state, isEnable) {
        state.isEnableKeywordHighlight = isEnable;
    },
    sethighlightConfig(state, highlightConfigPayload) {
        state.highlightConfig = deletableMerge(state.highlightConfig, highlightConfigPayload);
    },
    setListIds(state, ids) {
        state.listIds = ids;
    },
    /* 访问过于频繁的时候 */
    setIsOverFreeView(state, { isOverFree, message }) {
        state.isOverFreeView = isOverFree;
        state.overFreeViewMessage = message;
    },
    setIsShowingCommentBox(state, isShow) {
        state.isShowingCommentBox = isShow;
    },
    setIsShowingAddCommentBox(state, data) {
        if (isObject(data)) {
            state.isShowingAddCommentBox = data.display;
            state.addCommentBoxPosition = data.position || {};
        } else {
            state.isShowingAddCommentBox = data;
            state.addCommentBoxPosition = {};
        }
    },
    setIsShowingEditQuickComment(state, isShow) {
        state.isShowingEditQuickComment = isShow;
    },
    updateQuickComment(state, data) {
        state.quickComment = data;
    },
    updateSelectedPatentList(state, patent) {
        const list = state.selectedPatentList;
        const matchedIndex = findIndex(list, item => item.PATENT_ID === patent.PATENT_ID);
        if (matchedIndex === -1) {
            list.push(patent);
        } else {
            list.splice(matchedIndex, 1);
        }
    },
    emptySelectedPatentList(state) {
        state.selectedPatentList = [];
    },
};

const getters = {
    isUkLoading: ({ isUkLoading }) => isUkLoading,
    patentId: ({ patentId }) => patentId,
    isShowPatentList: ({ isShowPatentList }) => isShowPatentList,
    permissions: ({ permissions }) => permissions,
    isEnableKeywordHighlight: ({ isEnableKeywordHighlight }) => isEnableKeywordHighlight,
    highlightConfig: ({ highlightConfig }) => highlightConfig,
    listIds: ({ listIds }) => listIds,
    isOverFreeView: ({ isOverFreeView }) => isOverFreeView,
    overFreeViewMessage: ({ overFreeViewMessage }) => overFreeViewMessage,
    isShowingCommentBox: state => state.isShowingCommentBox,
    isShowingAddCommentBox: state => state.isShowingAddCommentBox,
    addCommentBoxPosition: state => state.addCommentBoxPosition,
    isShowingEditQuickComment: state => state.isShowingEditQuickComment,
    quickCommentList: state => (state.quickComment.comment_texts || []).map(item => item.comment_text),
    quickCommentId: state => state.quickComment.predefined_comment_id,
    selectedPatentList: state => state.selectedPatentList,
};

const actions = {
    setIsUkLoading({ commit }, isLoading) {
        commit('setUkLoading', isLoading);
    },
    setPatentId({ commit }, patentId) {
        commit('setPatentId', patentId);
    },
    setIsShowPatentList({ commit }, isShow) {
        commit('setIsShowPatentList', isShow);
    },
    setPermissions({ commit }, permissions) {
        commit('setPermissions', permissions);
    },
    setEnableKeywordHighlight({ commit }, bolPayload) {
        commit('setEnableKeywordHighlight', bolPayload);
    },
    sethighlightConfig({ commit }, config) {
        commit('sethighlightConfig', get(config, 'data', {}));
    },
    setListIds({ commit }, ids) {
        commit('setListIds', ids);
    },
    // what's this?
    setIsOverFreeView({ commit }, { isOverFree, message }) {
        commit('setIsOverFreeView', { isOverFree, message });
    },
    setIsShowingCommentBox({ commit }, bol) {
        commit('setIsShowingCommentBox', bol);
    },
    setIsShowingAddCommentBox({ commit }, data) {
        commit('setIsShowingAddCommentBox', data);
    },
    setIsShowingEditQuickComment({ commit }, data) {
        commit('setIsShowingEditQuickComment', data);
    },
    updateQuickComment({ commit }, data) {
        commit('updateQuickComment', data);
    },
    updateSelectedPatentList({ commit }, patent) {
        commit('updateSelectedPatentList', patent);
    },
    emptySelectedPatentList({ commit }) {
        commit('emptySelectedPatentList');
    },
};

export default {
    state,
    mutations,
    getters,
    actions
};
